export default "__VITE_ASSET__0497579f__"